




























import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '@shared/components/displays/abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import SendProductPaymentReminderMessageDrawer from '@shared/components/modals/send-product-payment-reminder-message-drawer/send-product-payment-reminder-message-drawer.vue';

@Component({
  components: { SendProductPaymentReminderMessageDrawer },
})
export default class DisplayFieldPaymentReminder extends mixins(AbstractDisplayField) {
  showDrawer: boolean = false;
  get contactIds(): number[] {
    return [this.item?.contact_id] || [];
  }

  get selectedItemIds(): number[] {
    return [this.item?.id] || [];
  }
  get entityName(): string {
    return this.fieldConfig.entity || '';
  }

  onClick() {
    this.showDrawer = true;
  }
}
